import styled from '@emotion/styled'
import GlBadgeClilIcon from '../../../../share/badge/GlBadgeClilIcon'
import GlPopularityPanel from '../../../../share/GlPopularityPanel'
import { getPopularityIndexByValue } from '../../../../../core/enums/popularity.enum'
import { ConstellationDataInterface } from '../../../../../core/interface/analytics/mirror/ConstellationDataInterface.interface'
import { AuthorMirrorAuthorInterface } from '../../../../../core/interface/report/author-mirror-author.interface'
import { AuthorNameStyle } from '../../../../../core/utils/get-author-initials'

const CardStyle = styled.div`
  padding: 8px;
  width: 258px;
  border-radius: 4px;
  background: white;
`

const TitleStyle = styled.div`
  color: #252525;
  font-family: Vollkorn, serif;
  font-size: 16px;
  font-style: italic;
  font-weight: 600;
  line-height: 20px; /* 125% */
  letter-spacing: 0.32px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`

const AuthorStyle = styled.div`
  color: #666;
  font-family: Fira Sans, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.24px;
`

const AuthorCardConstellation = ({
  data,
}: {
  data: ConstellationDataInterface<AuthorMirrorAuthorInterface>
}) => {
  const percentage =
    (data.mirror.distance &&
      `${Math.round((1 - data.mirror.distance) * 1000) / 10}%`) ||
    ''

  const popularity = getPopularityIndexByValue(data.mirror.popularity)
  return (
    <CardStyle className="flex flex-col gap-2 shadow-2xl">
      <div className="flex flex-row gap-2">
        <div className="flex-auto flex flex-col gap-2">
          <TitleStyle>{data.mirror.author.name}</TitleStyle>
        </div>
      </div>
      <GlPopularityPanel popularity={popularity} percentage={percentage} />
    </CardStyle>
  )
}
export default AuthorCardConstellation
